<template>
  <div style="border: 0 solid red;">
    <ClockControlledVisualBar :session-id="sessionId" />
    test
    <CommitmentVisualBar
      style="padding: 0.9em; padding-bottom: 0.4em"
      :max-value="visual_bar_max_minutes"
      unit="min"
      :percents="Object.values(aggregated_hours)"
      :color-map="color_map"
      @select="onSelectStats">
    </CommitmentVisualBar>

    <div class="session-task-list__progress-bar-caption">
      Planend {{visual_bar_sum_minutes}} of available {{visual_bar_max_minutes}} min ({{Math.round(visual_bar_sum_minutes/visual_bar_max_minutes*100)}}%)
    </div>

    <SortableList
      lockAxis="y"
      v-model="assigned_task_ids_sortable"
      :useDragHandle="true">
      <!-- TODO: It is possible, that the task got deleted and the id is invalid -->
      <SortableItem v-for="(task, index) in assigned_task_ids_sortable"
        :index="index"
        :key="'task-'+task.id"
        :goal-id="session.goalId"
        :task-id="task.id"
        :color="task.color"
        @remove-task="onRemoveTaskFromSession"
        />
    </SortableList>
    <div
      :class="dropzoneCssClasses('add')"
      @dragover.prevent.stop="onDragOverZone('add')"
      @dragleave.prevent.stop="currentDragZone = null"
      @drop="onItemDrop('ADD', $event)">
      Add to session
    </div>

    <div class="mt-2">
      <el-button @click="onAddTask">Add task</el-button>
      <el-button @click="onClearFinishedTasks" type="secondary">Clear Finished Tasks</el-button>
    </div>

    <hr>

    <!--
    TODO: Allow to use other Kanbans/Goals as task source?
    <h3>Select Goal</h3>
    <el-select v-model="selectedGoal" placeholder="Select">
      <el-option
        v-for="item in goalListSelection"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    -->

    <template v-if="effort">
      <!-- Effort is optional -->
      <h4>Effort:</h4>
      <InlineCommitment :commitment="effort" />
    </template>

    <!-- TODO: Warum hier nicht ganzes Kanban board anzeigen? -->
    <!-- <template v-if="selectedGoal">
      selectedGoal: {{selectedGoal}}
      <task-lane
        :key="selectedGoal"
        :goal="goal_by_id(selectedGoal)"
        :goal_id="selectedGoal"
        @drag-start="handleDragStart"
        @drag-end="handleDragEnd" />
    </template> -->

    <el-card class="m-4">
      <div slot="header">
        Tasklist from Goal: <router-link :to="'/goal/'+session.goalId"><strong>{{goal.name}}</strong></router-link>
      </div>
      <!-- TODO: ESC should clear text field -->
      <el-input v-model="taskFilterText" placeholder="Search for task ..." clearable />
      <div class="list" style="overflow-y: scroll; height: 300px; border: 5px solid rgb(77, 80, 132);">
        <task-list
          :goal_id="session.goalId"
          :tasklist="goal_tasklist_filtered"
          @drag-start="handleDragStart"
          @drag-end="handleDragEnd" />
      </div>
    </el-card>

    <template v-if="SHOW_DEBUG">
      <pre>
        aggregated_hours: {{aggregated_hours}}
        visual_bar_sum_minutes: {{visual_bar_sum_minutes}}
        visual_bar_max_minutes: {{visual_bar_max_minutes}}
      </pre>
      <pre>ASSIGNED_TASKS IDs (sortable): {{assigned_task_ids_sortable}}</pre>
      <pre>DRAGGING: {{dragging}}</pre>
      <pre>SAVEING:  {{savingDrag}}</pre>
      <!-- <pre>ASSIGNED_TASKS: {{assigned_tasks}}</pre> -->
      <pre>SESSION: {{session}}</pre>
      <pre>aggregated_hours: {{aggregated_hours}}</pre>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InlineCommitment from '@/components/Inline/InlineCommitment'
import CommitmentVisualBar from '@/components/Elements/CommitmentVisualBar'
import SortableList from './Tasks/SortableList'
import SortableItem from './Tasks/SortableItem'
import ClockControlledVisualBar from './Elements/ClockControlledVisualBar'
import TaskList from '@/components/GoalPage/Elements/TaskList'
// TODO ^ Replace this by FilteredTaskListForSession
import moment from '@/moment-gp.js'
import { COLOR_LIST } from "@/misc/colors";

/*
ACTIONS:
? this.goal_update_lane({ goal_id, lane_id, data });
? this.goal_assign_task_to_lane({ goal_id, lane_id, task_id });

? this.session_rem_assigned_task({ event_id, task_id });
X this.session_reorder_assigned_tasks({ event_id, batch });
X this.session_create_task_and_assign({ event_id, goal_id, sortidx });

X this.session_add_assigned_task({ event_id, task_id });
? this.session_update_assigned_task({ event_id, task_id, taskData });
X this.session_move_assigned_task_to_backlog({ event_id, task_id, goal_id });

GETTERS:
X this.checklist_items_by_goal_id_and_task_id(goal_id, task_id);
X this.assigned_tasks_by_event_id(session_id);
*/

export default {
  props: {
    sessionId: {
      type: String,
      default: null
    }
  },
  data: () => ({
    currentDragZone: null, /* MIXIN */
    dragging: false,
    savingDrag: false,
    selectedGoal: null,
    taskFilterText: "",
  }),
  computed: {
    ...mapGetters("goal", [ // <<< TODO
      "goal_by_id",
      // "effort_by_goal_id_and_effort_id",
      "goal_list_meta_ready_with_deleted",
      "unsorted_tasks"
    ]),
    ...mapGetters("calendar",[
      "event_by_id",
      "assigned_task_ids_by_event_id",
      "assigned_tasks_by_event_id"
    ]),

    session() {
      if ( this.sessionId ) {
        return this.event_by_id( this.sessionId );
      } else {
        return null;
      }
    },

    color_map() {
      return this.assigned_task_ids_with_random_color.map( task => task.color );
    },

    assigned_task_ids_with_random_color() {
      if ( this.sessionId ) {
        return this.assigned_task_ids_by_event_id( this.sessionId ).map(task_meta => {
          return {
            // TODO: Colors will change every time this getter is evaluated
            color: COLOR_LIST[ Math.floor( Math.random() * COLOR_LIST.length ) ],
            ...task_meta
          };
        });
      } else {
        return [];
      }
    },

    assigned_tasks() {
      if ( this.sessionId ) {
        return this.assigned_tasks_by_event_id( this.sessionId );
      } else {
        return [];
      }
    },

    goal_tasklist_filtered() {
      let taskList = this.goal_tasklist;
      if ( !this.taskFilterText ) {
        return taskList;
      }
      return taskList.filter(task => {
        return (task.name || '').toLowerCase().includes(this.taskFilterText.toLowerCase());
      })
    },

    goal_tasklist() {
      // TODO: This should go into a wrapper component around takslist called
      //       TaskLaneForSesison.vue

      // TODO: Implement different filters here
      //       - Filter assigned to me
      //       - Filter specific lane
      //       - Filter top priority (+ assigned to me)
      //       - etc.
      // TODO: Implement different sorters here (date, prio, ...)

      let alreadyAssigned = this.assigned_tasks.map(task => task.id);

      if ( this.session.goalId ) {
        // Careful: sortidx does not make sensere here

        /* Filter tasks that are already attached */
        let taskListFiltered = this
          .unsorted_tasks( this.session.goalId )
          .filter(task => {
            return !alreadyAssigned.includes( task.id )
          });
        return taskListFiltered;
      } else {
        return [];
      }
    },

    goal() {
      if ( this.session.goalId ) {
        return this.goal_by_id( this.session.goalId );
      } else {
        return null;
      }
    },

    visual_bar_max_minutes() {
      let end = moment( this.session.userEnd );
      let start = moment( this.session.userStart );
      let duration = moment.duration(end.diff(start));
      // console.log("duration", duration);
      return duration.asMinutes();
    },

    visual_bar_sum_minutes() {
      if ( this.aggregated_hours.length === 0 ) {
        return 0;
      }
      return Object.values(this.aggregated_hours).reduce((total, num) => (total + num), 0);
    },

    aggregated_hours() {
      let aggregated_hours = {};
      this.assigned_tasks.forEach(task => {
        let checklistItems = (task && task.checklist )
                             ? Object.keys(task.checklist).map(key => task.checklist[key])
                             : null;
        let checklistSumOfMinutes = checklistItems
                                  ? checklistItems.reduce((acc,item) => acc + item.duration, 0)
                                  : 0;
        aggregated_hours[task.id] = task.duration + checklistSumOfMinutes;
      })
      return aggregated_hours;
    },

    goalListSelection() {
      return this.goal_list_meta_ready_with_deleted.map(goal =>
        ({ 'value': goal.id, 'label': goal.cachedName }));
    },

    effort() {
      if ( this.session.goalId && this.session.commitmentId ) {
        return this.$models.commitment.with({ goalId: this.session.goalId }).subscribeNode( this.session.commitmentId )
        // return this.effort_by_goal_id_and_effort_id( this.session.goalId, this.session.commitmentId)
      }
      return null;
    },

    assigned_task_ids_sortable: {
      get() {
        // console.log("GETTER", this.sessionId);
        return this.assigned_task_ids_with_random_color;
      },
      set(items) {
        // console.log("GOT ITEMS", items);

        // let sortidx = 0;
        // let batch = items.map((item) => {
        //   sortidx = sortidx + 100;
        //   return { id: item.id, amount: sortidx }
        // })

        this.savingDrag = true;

        throw new Error('NOT_IMPLEMENTED')

        /*
        let batch = items.map(item => item.id)
        this.session_reorder_assigned_tasks({
           event_id: this.sessionId,
           batch: batch
        }).then(() => {
          this.savingDrag = false;
        });
        */
      }
    },
  },
  methods: {
    ...mapActions("calendar", [
      // "session_add_assigned_task",
      // "session_rem_assigned_task",
      // "session_update_assigned_task",
      // "session_reorder_assigned_tasks",
      // "session_create_task_and_assign",
      // "session_move_assigned_task_to_backlog"
    ]),

    onSelectStats(x) {
      console.log("onSelectStats", x);
    },

    onAddTask() {
      throw new Error('NOT_IMPLEMENTED')
      /*
      this.session_create_task_and_assign({
        event_id: this.sessionId,
        goal_id:  this.session.goalId
      });
      */
    },

    onRemoveTaskFromSession(task_id) {
      // this.session_rem_assigned_task({
      //   event_id: this.sessionId,
      //   task_id: task_id
      // });
      throw new Error('NOT_IMPLEMENTED')
      /*
      this.session_move_assigned_task_to_backlog({
        event_id: this.sessionId,
        goal_id: this.session.goalId,
        task_id: task_id,
      });
      */
    },

    onClearFinishedTasks() {
      console.log("onClearFinishedTasks - TODO");
    },

    /* ========================= DRAG AND DROP ========================= */

    /* ============ TODO: mixin ============ */

    dropzoneCssClasses(name) {
      return [
        'session-task-list-dropzone',
        ('dropzone-' + name),
        this.currentDragZone === name ? 'dropzone-active' : ''
      ];
    },

    handleDragStart(event) {
      this.dragging = true;
    },

    handleDragEnd() {
      this.dragging = false;
      this.currentDragZone = null;
    },

    onDragOverZone(zone) {
      this.currentDragZone = zone;
    },

    onItemDrop(target, event) {

      let dragData = {};
      try {
        dragData = JSON.parse( event.dataTransfer.getData("text") );
      } catch (e) {
        console.warn("Got invalid JSON", event.dataTransfer);
      }

      /* dragData.goalId  */
      console.log("eventItem", dragData);
      throw new Error('NOT_IMPLEMENTED')
      /*
      this.session_add_assigned_task({
        event_id: this.sessionId,
        task_id: dragData.taskId
      });
      */
    },
  },
  components: {
    CommitmentVisualBar,
    ClockControlledVisualBar,
    InlineCommitment,
    SortableList,
    SortableItem,
    TaskList,
  }
}
</script>

<style>
/* handle + list */
.task-list {
  margin: 0 auto;
  padding: 0.5em;
  overflow: auto;
  background-color: #f3f3f3;
}
.session-task-list__progress-bar-caption {
  margin: 0.5em 0;
  text-align: center;
  font-size: 12pt;
}
/* ===== DROPZONE ====== */
.session-task-list-dropzone {
  font-size: 12pt;
  font-weight: bold;
  border: 4px dashed #333;
  background-color: rgba(255, 255, 255, 0.85);
  text-align: center;
  vertical-align: middle;
  margin-top: 2px;
  height: 100px;
  padding-top: calc(50px - 12pt);
}
.session-task-list-dropzone.dropzone-add {
  margin: 1em;
}
.session-task-list-dropzone.dropzone-active {
  border: none;
  padding: 4px;
  padding-top: calc(50px - 12pt + 4px);
  background-image:
    linear-gradient(90deg, red 50%, transparent 0%),
    linear-gradient(90deg, red 50%, transparent 0%),
    linear-gradient(0deg, red 50%, transparent 0%),
    linear-gradient(0deg, red 50%, transparent 0%);
  background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
  background-size: 15px 4px, 15px 4px, 5px 15px, 4px 15px;
  background-position: left top, right bottom, left bottom, right   top;
  animation: border-dance 2s infinite linear;
}
@keyframes border-dance {
  0% {
    background-position: left top, right bottom, left bottom, right   top;
  }
  100% {
    background-position: left 15px top, right 15px bottom, left bottom 15px, right top 15px;
  }
}
</style>
